import React from 'react';
import Product from './Product';
import { useLanding } from 'utils';
import { useFeaturedProducts } from '../../store/hooks';
import {
  Wrapper,
  Title,
  InfoWrapper,
  ProductWrapper,
  OffertsWrapper,
} from './MiddleSection.style';

const MiddleSection = () => {
  const products = useFeaturedProducts();
  const { title } = useLanding();

  return (
    <Wrapper container>
      <InfoWrapper item xs={12} md={12}>
        {/* <Hint>{subtitle}</Hint> */}
        <Title>{title}</Title>
        {/* <Subtitle>{description}</Subtitle> */}
      </InfoWrapper>
      <OffertsWrapper container item xs={12} md={12}>
        {products.map((item) => (
          <ProductWrapper key={item.id} item xs={12} sm={6} md={4}>
            <Product data={item} />
          </ProductWrapper>
        ))}
      </OffertsWrapper>
    </Wrapper>
  );
};

export default MiddleSection;
